import DeleteIcon from '@mui/icons-material/Delete';
import IconButton from '@mui/material/IconButton';
import ListItem from '@mui/material/ListItem';
import ListItemSecondaryAction from '@mui/material/ListItemSecondaryAction';
import ListItemText from '@mui/material/ListItemText';
import Tooltip from '@mui/material/Tooltip';
import * as React from 'react';
import { ApSchedulerContact } from '../../../../../sic-lib/types/ApSchedulerContact';

interface Props {
    contact: ApSchedulerContact;
    onRemoveHandler: (event: React.MouseEvent<HTMLButtonElement>) => void;
}

export default function ApSchedulerListItem({ contact, onRemoveHandler }: Props) {
    return (
        <ListItem>
            <ListItemText primary={contact.name} />
            <ListItemSecondaryAction>
                <Tooltip title="Remove">
                    <IconButton
                        data-contact-id={contact.contactId}
                        onClick={onRemoveHandler}
                        size="large"
                    >
                        <DeleteIcon />
                    </IconButton>
                </Tooltip>
            </ListItemSecondaryAction>
        </ListItem>
    );
}
